import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = {
    class: "sr-only",
    for: "meter-scoring-prompt"
};
const _hoisted_3 = { class: "form-check" };
import { ref } from 'vue';
import BaseModal from './BaseModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MeterScoringPromptModal',
    emits: ["save"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const meterId = ref('');
        const prompt = ref('');
        const complement = ref(true);
        const isOpen = ref(false);
        const open = (selectedMeterId, config) => {
            meterId.value = selectedMeterId;
            prompt.value = config?.prompt ?? '';
            complement.value = config?.complement !== false;
            isOpen.value = true;
        };
        const save = () => {
            emit('save', {
                meterId: meterId.value,
                prompt: prompt.value,
                complement: complement.value,
            });
            isOpen.value = false;
        };
        __expose({ open });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(BaseModal, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((isOpen).value = $event)),
                "modal-id": "meter-scoring-prompt-modal",
                title: `Edit ${meterId.value} Scoring Prompt`,
                onSave: save
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("label", _hoisted_2, " Scoring prompt for " + _toDisplayString(meterId.value), 1),
                        _withDirectives(_createElementVNode("textarea", {
                            id: "meter-scoring-prompt",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((prompt).value = $event)),
                            autofocus: "",
                            class: "form-control",
                            rows: "8"
                        }, null, 512), [
                            [_vModelText, prompt.value]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            id: "meter-scoring-prompt-complement",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((complement).value = $event)),
                            class: "form-check-input",
                            type: "checkbox"
                        }, null, 512), [
                            [_vModelCheckbox, complement.value]
                        ]),
                        _cache[3] || (_cache[3] = _createElementVNode("label", {
                            class: "form-check-label",
                            for: "meter-scoring-prompt-complement"
                        }, " Complement simulation-level scoring prompt ", -1))
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("small", { class: "form-text text-muted" }, " When unchecked, this prompt replaces the simulation-level prompt for this meter. The Scoring Assistant Prompt is always included. ", -1))
                ]),
                _: 1
            }, 8, ["modelValue", "title"]));
        };
    }
});
